// Angular Core Modules
import { Component, inject, OnInit } from '@angular/core';
import { AsyncPipe, NgIf } from '@angular/common';

// Third Party Modules
import { Store } from '@ngrx/store';

// Application Modules
import { selectCurrentConsumer } from '@app/resources/ngrx/selectors';
import { NonMemberDisplayCardComponent } from '@app/areas/non-members/components/non-member-display-card/non-member-display-card.component';
import { ApplicationProfileService } from '@app/@shared/services/application-profile.service';
import { PortalTheme } from '@app/@shared/models';

@Component({
  selector: 'app-non-member',
  standalone: true,
  imports: [NonMemberDisplayCardComponent, AsyncPipe, NgIf],
  template: `
    <div *ngIf="nonMember$ | async; let nonMember" class="non-member-wrapper">
      <app-non-member-display-card [nonMember]="nonMember" [theme]="theme" class="w-100" />
    </div>
  `,
  styleUrl: './non-member.component.scss',
})
export class NonMemberComponent implements OnInit {
  private readonly store = inject(Store);
  private readonly applicationProfileService = inject(ApplicationProfileService);

  protected theme!: PortalTheme;
  protected nonMember$ = this.store.select(selectCurrentConsumer);

  ngOnInit(): void {
    this.applicationProfileService.applicationProfile$.subscribe((profile) => {
      this.theme = profile.PortalTheme.Theme;
    });
  }
}
